import React, { useEffect, useState, lazy } from 'react';

import GatsbyImage from '../../Image/GatsbyImage';
import Video from '../../Video';

import { Container } from '../styles/Media.styled';
import fetchAnimation from '../../Lottie/utils/fetchAnimation';

const Lottie = lazy(() => import('../../Lottie/Lottie'));

const Media = ({ reference, reverse, layout }) => {
  const isGif = reference?.image?.format === 'gif';
  const [animation, setAnimation] = useState();

  useEffect(() => {
    if (reference?.lottie) {
      fetchAnimation(reference?.lottie?.url, setAnimation);
    }
  }, [reference?.lottie]);

  return (
    <Container
      className="switchback-media"
      reference={reference}
      reverse={reverse}
      layout={layout}
      isGif={isGif}
    >
      {reference?.__typename === 'DatoCmsWebsiteImage' && (
        <GatsbyImage
          src={reference?.image?.gatsbyImageData}
          alt={reference?.image?.alt}
          format={reference?.image?.format}
          fallbackUrl={reference?.image?.url}
        />
      )}
      {reference?.__typename === 'DatoCmsWebsiteVideo' && (
        <Video {...reference} />
      )}
      {reference?.__typename === 'DatoCmsLottieAnimation' && (
        <div className="lottie">
          <Lottie
            animation={animation}
            delay={250}
            loop={reference?.loop || false}
            autoplay={reference?.autoplay || false}
          />
        </div>
      )}
    </Container>
  );
};

export default Media;
